<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto custom-scrollbar">

    <div *ngIf="isLoading() || isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">manage_accounts</span>
        ข้อมูลส่วนตัว
      </h3>
      <button type="button" (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-5">
      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Username</label>
        <div class="p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
          <p class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ login || '—' }}</p>
          <p class="text-[11px] text-slate-400 mt-0.5">ไม่สามารถแก้ไข Username ได้</p>
        </div>
      </div>

      <div *ngIf="roleName">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">บทบาท</label>
        <p class="text-sm font-semibold text-slate-600 dark:text-slate-300">{{ roleName }}</p>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
          ชื่อที่แสดง <span class="text-rose-500">*</span>
        </label>
        <input type="text" [(ngModel)]="displayName" name="displayName" placeholder="ชื่อ-นามสกุล"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">อีเมล</label>
        <input type="text" [(ngModel)]="email" name="email" placeholder="email@company.com"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">เบอร์โทร</label>
        <input type="text" [(ngModel)]="phone" name="phone" placeholder="08xxxxxxxx"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
      </div>

      <div class="border-t border-slate-100 dark:border-slate-800 pt-5">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสผ่าน (City Login)</label>
        <p *ngIf="!hasCityPassword" class="text-xs text-amber-600 font-medium">
          ยังไม่ได้ตั้งรหัส City Login — จะตั้งได้ตอนเข้าสู่ระบบครั้งแรก
        </p>
        <button *ngIf="hasCityPassword" type="button" (click)="openPasswordModal()"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 hover:bg-amber-50 dark:hover:bg-slate-700 text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center justify-between cursor-pointer transition-colors">
          <span class="flex items-center gap-2">
            <span class="material-icons text-[18px] text-amber-500">lock_reset</span>
            เปลี่ยนรหัสผ่าน
          </span>
          <span class="material-icons text-[18px] text-slate-400">chevron_right</span>
        </button>
      </div>
    </div>

    <div class="flex items-center justify-end gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button type="button" (click)="onClose()"
        class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 dark:text-slate-400 font-bold rounded-xl shadow-sm transition-all active:scale-95 cursor-pointer border-none">
        ยกเลิก
      </button>
      <button type="button" (click)="onSave()"
        class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-amber-400/20 hover:-translate-y-0.5 transition-all active:scale-95 cursor-pointer border-none">
        บันทึก
      </button>
    </div>
  </div>
</div>

<app-modal-change-my-password *ngIf="isPasswordModalOpen"
  (close)="closePasswordModal()">
</app-modal-change-my-password>
